import { render, staticRenderFns } from "./Term.vue?vue&type=template&id=81715bb4&"
var script = {}
import style0 from "./Term.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports